import React, { useState, useEffect } from "react";
import ItemLocation from "./ItemLocation";
import styled from "styled-components";
import { CircularProgress } from "@material-ui/core";
import { HiHome } from "react-icons/hi";
import { Link } from "react-router-dom";

const CitiesContainer = () => {
	const [cities, setCities] = useState();

	const getData = async () => {
		let localCities = await fetch("./JSON/cities.json");
		let data = await localCities.json();
		let images = await fetch("./JSON/weather.json");
		let dataImages = await images.json();
		let newArray = [];
		for (let i = 0; i < data.length; i++) {
			let response = await fetch(
				`http://api.weatherapi.com/v1/current.json?key=a8373ca4b4c54ee8ad7230401220803&q=${data[i].cityName}&aqi=no`
			);
			let toReturn = await response.json();
			if (!toReturn) return;
			let url = searchImage(
				toReturn.current.condition.code,
				toReturn.current.is_day,
				dataImages
			);
			newArray.push({ element: toReturn, image: `${url}` });
		}
		setCities(newArray);
	};
	useEffect(() => {
		getData();
	}, []);

	const searchImage = (code, day, array) => {
		const info = array.find((element) => element.code === code);

		return day === 1 ? info.dayImageUrl : info.nightImageUrl;
	};

	return (
		<StyledContainer>
			<Link to="/">
				<HiHome size={30} />
			</Link>
			{cities === undefined ? (
				<StyledSpinner />
			) : (
				<StyledDiv>
					{cities.map((element) => (
						<ItemLocation
							element={element.element}
							backgroundImage={element.image}
						/>
					))}
				</StyledDiv>
			)}
		</StyledContainer>
	);
};

export default CitiesContainer;

const StyledDiv = styled.div`
	display: flex;
	justify-content: space-around;
	align-items: center;
	flex-wrap: wrap;
	padding: 60px;
`;

const StyledSpinner = styled(CircularProgress)`
	margin: 25% 0;
`;

const StyledContainer = styled.section`
	background-image: url("https://i.imgur.com/vaGoRVP.jpg");
	background-size: cover;
	height: 100vh;
	height: 100%;
	text-align: center;
	a {
		cursor: pointer;
		text-decoration: none;
		color: #ffffff;
		position: absolute;
		z-index: 1;
		top: 3%;
		left: 3%;
	}
`;
